import { render } from "./popular.vue?vue&type=template&id=0a979a34"
import script from "./popular.vue?vue&type=script&lang=js"
export * from "./popular.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Programming\\Padmaweb\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__